import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
//TW20251010
import { OfficeLeaseDetail, OfficeLeaseBuildingGraph, OfficeLeaseDetailBuildingFloor, OfficeLeaseDetailRO } from '../../core/models/office-lease';
//END OF TW20251010
import { FormBuilder, FormGroup } from '@angular/forms';
import { SortConfig } from '../../core/interface/SortConfig';
import { PaginationConfig } from '../../core/interface/PaginationConfig';
import { debounceTime, distinctUntilChanged, Subject, Subscription, takeUntil } from 'rxjs';
import { OfficeLeaseService } from '../../core/services/office-lease.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TenantModalService } from '../../core/tenant-modal/tenant-modal.service';
import { BuildingModalService } from '../../core/building-modal/building-modal.service'; //TW20251010

@Component({
  selector: 'app-office-lease-detail',
  templateUrl: './office-lease-detail.component.html',
  styleUrl: './office-lease-detail.component.css'
})
export class OfficeLeaseDetailComponent implements OnInit, OnDestroy {
  @Input('tenantInfo') tenantData: string[] = [];


  itemGraph: OfficeLeaseBuildingGraph[] = []; //TW20251010
  itemLease: OfficeLeaseDetailBuildingFloor[] = [];
  itemLeaseDetail: OfficeLeaseDetail = {} as OfficeLeaseDetail;
  itemLeaseDetailRO: OfficeLeaseDetailRO[] = [];
  isLoading = false;
  error = '';

  // Filters
  searchForm !: FormGroup;
  sortBy = '';
  startDate: string = '';
  endDate: string = ''

  sortConfig: SortConfig = {
    column: '',
    direction: ''
  };

  paginationConfig: PaginationConfig = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0
  };

  searchTerm: string = '';

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();
  showFloorDetails: boolean = false;

  // Office details
  officeId: string = '';
  officeName: string = 'iNews Tower';
  floorDetails: OfficeLeaseDetailBuildingFloor | null = null;
  tenantCount: number = 0;

  images: string[] = [];
  currentImageIndex: number = 0;

  // Template reference and modal
  @ViewChild('floorDetailsModal') floorDetailsModalTemplate!: TemplateRef<any>;
  private modalRef: NgbModalRef | null = null;
  private routeSub: Subscription | null = null;

  constructor(
    private officeLeaseService: OfficeLeaseService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private modalServiceTenant: TenantModalService,
    private modalServiceBuilding: BuildingModalService //TW20251010

  ) {

    this.setupSearchSubscription();

    this.searchForm = this.fb.group({
      searchTerm: ['']
    });
  }

  private setupSearchSubscription(): void {
    this.searchSubject.pipe(
      takeUntil(this.destroy$),
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      // Update URL dan load data hanya jika ada term
      if (term.trim()) {
        this.updateUrlParams();
      }
      this.loadOfficeLeaseDetailBuildingFloor(term);
    });
  }



  ngOnInit(): void {

    const startDate = localStorage.getItem('startDate')
    const endDate = localStorage.getItem('endDate')

    this.startDate = startDate ? startDate : '';
    this.endDate = endDate ? endDate : '';


    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.searchTerm = params['search'] || '';
        this.sortConfig.column = params['sortColumn'] || '';
        this.sortConfig.direction = params['sortDirection'] as 'ASC' | 'DESC' | '' || '';
        this.paginationConfig.currentPage = Number(params['page']) || 1;

        this.loadOfficeLeaseDetailBuildingFloor(this.searchTerm);
      });

    const paramsId = this.route.snapshot.paramMap.get('id');

    // this.routeSub = this.route.params.subscribe(params => {
    //   this.officeId = paramsId || '';
    //   // You would typically fetch office details from a service here
    //   this.loadOfficeLeaseDetailBuildingFloor(this.officeId);
    // });

    this.route.queryParams.subscribe(params => {
      if (paramsId) {
        this.showFloorDetails = true;
      }
    });

    this.loadOfficeLeaseDetail();
    this.loadOfficeLeaseDetailRO();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    // Clean up subscriptions
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }

    // Close any open modals when component is destroyed
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  showTenantDetails(tenantData: string | string[], event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    let formattedTenants: string[] = [];

    // Handle different types of tenant data
    if (Array.isArray(tenantData)) {
      // If tenantData is already an array, format each item
      formattedTenants = tenantData
        .filter(tenant => tenant && tenant.trim().length > 0)
        .map(tenant => tenant.trim() + ',');
    } else if (tenantData && typeof tenantData === 'string') {
      // If tenantData is a string, split and format
      if (tenantData.includes(',')) {
        formattedTenants = tenantData
          .split(',')
          .map(tenant => tenant.trim())
          .filter(tenant => tenant.length > 0)
          .map(tenant => tenant + ',');
      } else if (tenantData.includes(';')) {
        formattedTenants = tenantData
          .split(';')
          .map(tenant => tenant.trim())
          .filter(tenant => tenant.length > 0)
          .map(tenant => tenant + ',');
      } else {
        // Single tenant
        formattedTenants = [tenantData.trim() + ','];
      }
    }

    // Open the modal with the formatted tenant array - no need for position anymore
    this.modalServiceTenant.openModal(formattedTenants);
  }

  loadOfficeLeaseDetailRO(): void {
    this.isLoading = true;
    const paramsId = this.route.snapshot.paramMap.get('id');

    this.officeLeaseService.getOfficeLeaseDetaiRO(
      Number(paramsId),
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.itemLeaseDetailRO = response.data;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading Office Lease Detail Revenue & Occupancy data:', error);
        this.isLoading = false;
        this.itemLeaseDetailRO = [];
      }
    });
  }

  loadOfficeLeaseDetail(): void {
    this.isLoading = true;
    const paramsId = this.route.snapshot.paramMap.get('id');

    this.officeLeaseService.getOfficeLeaseDetail(
      Number(paramsId),
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.itemLeaseDetail = response.data;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading Office Lease Detail data:', error);
        this.isLoading = false;
        this.itemLeaseDetail = {} as OfficeLeaseDetail;
      }
    });
  }

  loadOfficeLeaseDetailBuildingFloor(searchTerm?: string): void {
    this.isLoading = true;
    this.error = ''; // Reset error sebelumnya
    const paramsId = this.route.snapshot.paramMap.get('id');
    console.log(paramsId);

    this.officeLeaseService.getOfficeLeaseDetailBuildingFloor(
      paramsId || '',
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      searchTerm?.trim() || '',
      this.sortConfig.column,
      this.sortConfig.direction ? this.sortConfig.direction.toUpperCase() as 'ASC' | 'DESC' : undefined,
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        if (response && response.data) {
          // Memeriksa struktur respons sebelum mengassign
          this.itemLease = response.data;
          this.floorDetails = response.data.length > 0 ? response.data[0] : null;
          // this.openFloorDetailsModal(this.floorDetails);

          if (response.pagination) {
            this.paginationConfig.totalItems = response.pagination.total_items;
            this.paginationConfig.currentPage = response.pagination.current_page;
          }

          this.isLoading = false;
        } else {
          this.error = 'Respons API tidak valid';
          this.isLoading = false;
          this.itemLease = [];
        }
      },
      error: (error) => {
        let errorMessage = 'Error saat memuat data residences: ';

        if (error.status === 200 && error.statusText === 'OK') {
          errorMessage += 'Error saat memproses format respons JSON';
        } else if (error.error instanceof ErrorEvent) {
          // Error dari sisi client
          errorMessage += `Error client: ${error.error.message}`;
        } else {
          // Error dari sisi server
          errorMessage += `Kode: ${error.status}, Pesan: ${error.message}`;
        }

        console.error(errorMessage, error);
        this.error = errorMessage;
        this.isLoading = false;
        this.itemLease = [];
      }
    });
  }

  onSearch(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const term = target.value;

    // Update searchTerm dan trigger pencarian
    this.searchTerm = term;
    this.paginationConfig.currentPage = 1;
    this.searchSubject.next(term);

    // Jika input kosong, langsung clear search dan reset data
    if (!term.trim()) {
      const queryParams: Record<string, string | number | null> = {
        page: 1,
        search: null
      };

      // Jika ada sort config, pertahankan
      if (this.sortConfig.column && this.sortConfig.direction) {
        queryParams['sortColumn'] = this.sortConfig.column;
        queryParams['sortDirection'] = this.sortConfig.direction;
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        replaceUrl: true
      });

      this.loadOfficeLeaseDetailBuildingFloor('');
    }
  }

  onSort(column: string): void {
    if (this.sortConfig.column === column) {
      this.sortConfig.direction = this.sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortConfig.column = column;
      this.sortConfig.direction = 'ASC';
    }

    this.paginationConfig.currentPage = 1; // Reset to first page on sort
    this.updateUrlParams();
    this.loadOfficeLeaseDetailBuildingFloor(this.searchTerm);
  }

  getSortIcon(column: string): string {
    // Jika bukan kolom yang sedang di-sort, tampilkan icon default
    if (this.sortConfig.column !== column) {
      return 'ri-expand-up-down-line'; // Remix icon untuk unsorted
    }

    // Jika kolom yang sedang di-sort
    if (this.sortConfig.direction === 'ASC') {
      return 'ri-arrow-up-line'; // Remix icon arrow up
    } else if (this.sortConfig.direction === 'DESC') {
      return 'ri-arrow-down-line'; // Remix icon arrow down
    }

    return 'ri-expand-up-down-line'; // Default fallback
  }

  private updateUrlParams(): void {
    const queryParams: any = {
      page: this.paginationConfig.currentPage
    };

    // Hanya tambahkan search param jika ada nilai
    if (this.searchTerm?.trim()) {
      queryParams.search = this.searchTerm.trim();
    } else {
      queryParams.search = null; // Hapus search param
    }

    if (this.sortConfig.column && this.sortConfig.direction) {
      queryParams.sortColumn = this.sortConfig.column;
      queryParams.sortDirection = this.sortConfig.direction;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  get totalPages(): number {
    return Math.ceil(this.paginationConfig.totalItems / this.paginationConfig.itemsPerPage);
  }

  get pageNumbers(): number[] {
    const currentPage = this.paginationConfig.currentPage;
    const totalPages = this.totalPages;

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  get displayRange(): { start: number; end: number; total: number } {
    const start = (this.paginationConfig.currentPage - 1) * this.paginationConfig.itemsPerPage + 1;
    const end = Math.min(
      start + this.paginationConfig.itemsPerPage - 1,
      this.paginationConfig.totalItems
    );

    return {
      start: this.paginationConfig.totalItems === 0 ? 0 : start,
      end,
      total: this.paginationConfig.totalItems
    };
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.paginationConfig.currentPage = 1;
    this.updateUrlParams();
    this.loadOfficeLeaseDetailBuildingFloor('');
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.paginationConfig.currentPage) {
      return;
    }

    this.paginationConfig.currentPage = page;
    this.updateUrlParams();
    this.loadOfficeLeaseDetailBuildingFloor(this.searchTerm);
  }


  onFirstPage(): void {
    this.onPageChange(1);
  }

  onLastPage(): void {
    this.onPageChange(this.totalPages);
  }


  onPrevPage(): void {
    this.onPageChange(this.paginationConfig.currentPage - 1);
  }

  onNextPage(): void {
    this.onPageChange(this.paginationConfig.currentPage + 1);
  }

  // Image navigation methods
  nextImage(): void {
    if (this.currentImageIndex < this.images.length - 1) {
      this.currentImageIndex++;
    }
  }

  prevImage(): void {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
    }
  }

  // Helper method to extract valid image paths
  private extractImagePaths(galleries: any[]): string[] {
    if (!galleries || !Array.isArray(galleries)) {
      return [];
    }

    return galleries
      .filter(gallery => gallery && gallery.image_path && gallery.image_path.trim() !== '')
      .map(gallery => gallery.image_path);
  }

  // Open the floor details modal
  openFloorDetailsModal(item?: any): void {

    this.floorDetails = item || null;
    this.tenantCount = item?.tenant.length;
    this.images = this.extractImagePaths(item?.galleries || []);



    console.log('Images:', this.images);
    console.log('Floor Details:', item);
    console.log(this.floorDetails);

    // Open modal with exact classes as requested
    this.modalRef = this.modalService.open(this.floorDetailsModalTemplate, {
      windowClass: 'floor-details-modal',
      modalDialogClass: 'modal-xl modal-dialog-centered',
      backdrop: 'static',
      animation: true
    });
  }


}
